import { queryClient } from '@/libs/react-query/query-client'

import {
  notDispatchedShipmentOrderQueryTypes,
  vehicleDispatchBoardsQueryKeys
} from '../query-keys'

/**
 * 配車板（新API vehicle-dispatch-boards）と未配車系キャッシュの invalidate。
 *
 * queryCachePatcher から独立させているのは、楽観更新（optimistic-board-patch）の
 * 巻き戻しが API 層から使うため。queryCachePatcher は api バレルへ依存しており、
 * api 層 → queryCachePatcher の import は循環になる。
 */

/** 新API (vehicle-dispatch-boards) の板キャッシュのキー prefix */
export const newBoardQueryKey =
  vehicleDispatchBoardsQueryKeys.vehicleDispatchBoards()

/** 新API (vehicle-dispatch-boards) キャッシュをプレフィックスマッチで全件 invalidate */
export const invalidateNewBoardCache = () => {
  return queryClient.invalidateQueries({
    queryKey: newBoardQueryKey
  })
}

/**
 * 未配車系（一覧・全件・合計重量・束ねカード）をプレフィックスマッチで invalidate する。
 * 一覧キャッシュのキーはドロワー側の表示日（日付連動時は横スクロール位置由来）で
 * 組まれるため、板側の基準日で exact に組むと当たらない。日付を含めず prefix で当てる。
 */
export const invalidateNotDispatchedShipmentOrderCaches = async () => {
  for (const key of notDispatchedShipmentOrderQueryTypes) {
    await queryClient.invalidateQueries({
      queryKey: [vehicleDispatchBoardsQueryKeys.all[0], key]
    })
  }
}
